module.exports = __webpack_public_path__ + "static/media/sub-3.f81f3e00.png";